module.exports = __webpack_public_path__ + "img/new-home-page-guide-drawer-illustration-fr4.be1c9e7.png";